import * as async from "async";
import Backbone from "backbone";
import $ from "jquery";
import * as mustache from "mustache";
import Sortable from "sortablejs";
import * as _ from "underscore";

import compositeViewMixin from "compositeViewMixin";
import * as genericModals from "genericModals";
import * as listActionsButton from "listActionsButton";
import * as mustcache from "mustcache";
import SelectionActionList from "SelectionActionList";
import * as utils from "shared/utils";
import AddToShelfView from "views/AddToShelfView";
import SelectAllView from "views/SelectAllView";
import SelectionActionView from "views/SelectionActionView";

const PrivateLibraryListView = Backbone.View.extend({
  initialize: function (options) {
    _.extend(this, compositeViewMixin);

    this.options = options;
    this.books = options.books;
    this.models = options.models;

    this.shelf = this.models.shelves.get(this.options.shelfID);
    if (this.options.shelf /* && this.options.shelfID !== 'unshelved'*/) {
      this.listenTo(this.shelf, "change:books", () => {
        this.filterTextsBasedOnShelf();
      });
      this.listenTo(this.shelf, "change:public", this.render.bind(this));
    }

    this.listenTo(this.books.selectionModel, "change:wholePage", () => {
      if (this.books.selectionModel.get("wholePage")) {
        this.$el.find('input[type="checkbox"]').prop("checked", true);
      } else {
        this.$el.find('input[type="checkbox"]').prop("checked", false);
      }
    });

    this.listenTo(this.books.selectionModel, "change:itemIDs", () => {
      const selectedIDs = this.books.selectionModel.get("itemIDs");

      this.$el.find("tr").each((index, row) => {
        const $row = $(row);
        const selected = _.contains(selectedIDs, $row.attr("data-bookID"));

        if (selected) {
          $row.addClass("selected");
          $row.find('input[type="checkbox"]').prop("checked", true);
        } else {
          $row.removeClass("selected");
          $row.find('input[type="checkbox"]').prop("checked", false);
        }
      });
    });

    this.listenTo(this.books, "change", (book) => {
      // re-render
      const selected = this.$book(book).hasClass("selected");
      this.$book(book).replaceWith(this.getBookHtml(book));
      if (selected) {
        this.$book(book).addClass("selected");
        this.$book(book).find('input[type="checkbox"]').prop("checked", true);
      }
      this.showOrHideBook(book, { amendSelection: true });
      this.books.selectionModel.trigger("change:count");
    });

    this.listenTo(this.books, "remove", (book) => {
      this.$book(book).fadeOut();
      this.books.selectionModel.removeItem(book.id);
    });

    this.selectionActionList = new SelectionActionList(
      [
        {
          id: "restoreToReadingQueue",
          name: "Restore to Reading Queue",
          applyQuery: {
            "userBook.tags": { $size: 0 },
          },
        },
        {
          id: "restoreToCompleted",
          name: "Restore to Completed Texts",
          applyQuery: {
            "userBook.tags": { $size: 0 },
          },
        },
        {
          id: "restoreToArchive",
          name: "Restore to Archive",
          applyQuery: {
            "userBook.tags": { $size: 0 },
          },
        },

        { id: "splitter1", splitter: true },

        {
          id: "permanentlyDeleteTexts",
          name: "Permanently Delete Text",
          namePlural: "Permanently Delete Texts",
          applyQuery: {
            "userBook.tags": { $size: 0 },
          },
        },

        { id: "splitter2", splitter: true },

        {
          id: "removeFromShelf",
          name: "Remove From Shelf",
          applyQuery: {
            shelf: { $exists: true },
          },
        },

        { id: "splitter3", splitter: true },

        {
          id: "addToReadingQueue",
          name: "Queue to Read",
          applyQuery: {
            $and: [
              { "userBook.tags": { $ne: "queue" } },
              { "userBook.tags": { $not: { $size: 0 } } },
            ],
          },
        },
        {
          id: "markAsCompleted",
          name: "Mark as Completed",
          applyQuery: {
            $and: [
              { "userBook.tags": { $ne: "completed" } },
              { "userBook.tags": { $not: { $size: 0 } } },
            ],
          },
        },
        {
          id: "archiveTexts",
          name: "Archive Text",
          namePlural: "Archive Texts",
          applyQuery: {
            $and: [
              { "userBook.tags": { $ne: "abandoned" } },
              { "userBook.tags": { $not: { $size: 0 } } },
            ],
          },
        },

        { id: "splitter4", splitter: true },

        {
          id: "share",
          name: "Share Publicly",
          namePlural: "Share Publicly",
          applyQuery: {
            public: { $ne: true },
            "ownerID._id": this.models.user.id,
            "userBook.tags": { $not: { $size: 0 } },
          },
        },
        {
          id: "shareUnlisted",
          name: "Share to Anyone With Link",
          namePlural: "Share to Anyone With Link",
          // namePlural: "Share Texts",
          applyQuery: {
            public: { $ne: true },
            "ownerID._id": this.models.user.id,
            "userBook.tags": { $not: { $size: 0 } },
          },
        },
        {
          id: "unShare",
          name: "Un-Share Text",
          namePlural: "Un-Share Texts",
          applyQuery: {
            public: true,
            "ownerID._id": this.models.user.id,
          },
        },

        { id: "splitter5", splitter: true },

        {
          id: "deleteTexts",
          name: "Delete Text",
          namePlural: "Delete Texts",
          applyQuery: {
            $and: [
              //{'userBook.tags': {$ne: 'shared'}},
              { "userBook.tags": { $not: { $size: 0 } } },
            ],
          },
          // TODO: move this function out of this list
          exec: () => {
            const itemIDs = this.books.selectionModel.get("itemIDs");

            const shared = _.filter(
              this.books.selectionModel.getSelectedItems(),
              (books) => _.contains(books.get("userBook").tags, "shared")
            );

            if (shared.length > 0) {
              alert(
                "Can't delete since the following texts are shared publicly: \n\n- " +
                  _.map(shared, (book) => book.get("title")).join("\n- ") +
                  "\n\nUn-share these texts first before deleting them."
              );
              console.log("REFUSED");
              return;
            }

            const shelves = this.models.shelves.shelvesContainingBooks(itemIDs);

            async.series(
              [
                (callback) => {
                  if (shelves.length === 0) {
                    callback();
                    return;
                  }

                  const shelfNames = _.map(shelves, (shelf) =>
                    shelf.get("name")
                  );
                  genericModals.confirm({
                    title: "Delete Text" + (itemIDs.length === 1 ? "" : "s"),
                    message:
                      "Are you sure you want to delete " +
                      (itemIDs.length === 1
                        ? "this text? It"
                        : "these " + itemIDs.length + " texts? They") +
                      " will be removed from the " +
                      "following " +
                      (this.models.shelves.length === 1 ? "shelf" : "shelves") +
                      ": \n\n- " +
                      shelfNames.join("\n- "),
                    callback: (response) => {
                      if (response === "ok") {
                        callback();
                      } else {
                        // @ts-ignore
                        callback("cancelled");
                      }
                    },
                  });
                },
              ],
              (err) => {
                if (err) {
                  return;
                }

                // TODO: deleting books from shelves should probably be done from Shelves or Shelf
                if (this.models.shelves.unshelved) {
                  const books = _.filter(
                    this.models.shelves.unshelved.get("books"),
                    (book) => !_.contains(itemIDs, book.bookID)
                  );
                  this.models.shelves.unshelved.set({ books: books });
                }

                async.each(
                  shelves,
                  (shelf, callback) => {
                    const books = _.filter(
                      shelf.get("books"),
                      (book) => !_.contains(itemIDs, book.bookID)
                    );

                    shelf.save(
                      { books: books },
                      {
                        patch: true,
                        success: () => {
                          callback();
                        },
                      }
                    );
                  },
                  () => {
                    this.books.deleteTexts();
                  }
                );
              }
            );
          },
        },
      ],
      { selectionModel: this.selectionModel }
    );

    this.render();
  },
  render: function () {
    mustcache.render("libraryListView2", {}, (html) => {
      this.$el.html(html);
      this.renderBookTable();
      this.setSubviews({
        addToShelfView: new AddToShelfView({
          el: this.$('[data-subview="addToShelfDropdown"]'),
          model: this.books.selectionModel,
          models: this.models,
          finishEditingCallback: () => {
            this.filterTextsBasedOnShelf({ amendSelection: true });
          },
        }),
        selectAllView: new SelectAllView({
          model: this.books.selectionModel,
          el: this.$(".selectAllContainer"),
        }),
        actionView: new SelectionActionView({
          name: "Actions",
          heading: "Perform action",
          model: this.books.selectionModel,
          el: this.$('[data-subview="actionsDropdown"]'),
          width: "220px",
          itemIDsOnly: true,
          selectionActionList: this.selectionActionList,
        }),
      });

      // TODO: this doesn't seem to work on the dropdown list - because modalDialog?
      this.delegateEvents(this.events);
    });
  },
  columns: [
    {
      name: "dragHandle",
      header: "",
      content: '<i class="icon-align-justify"></i>',
    },
    {
      name: "checkbox",
      header:
        '<div class="checkboxCell selectAllContainer toolbarButton">' +
        '  <input type="checkbox" class="selectAll" id="selectAllCheckbox"></input>' +
        '  <label for="selectAllCheckbox">' +
        '    <i class="icon-check"></i>' +
        '    <i class="icon-check-empty"></i>' +
        '    <i class="icon-check-minus"></i>' +
        "  </label>" +
        "</div>",
      content:
        '<div class="checkboxCell clickable">' +
        '<input type="checkbox" data-bookID="{{_id}}" id="checkbox-{{_id}}"></input>' +
        '<label class="checkboxLabel" for="checkbox-{{_id}}">' +
        '  <i class="icon-check"></i>' +
        '  <i class="icon-check-empty"></i>' +
        '  <i class="icon-check-minus"></i>' +
        "</label>" +
        "</div>",
    },
    {
      name: "title",
      header: "Name",
      content:
        '<a href="/library/{{_id}}">{{shortTitle}}</a> ' +
        "{{#youTubeID}}<small>(video)</small>{{/youTubeID}}" +
        "{{#audioFileID}}<small>(audio)</small>{{/audioFileID}}" +
        '<div><small><span class="description">{{description}}</span></small></div>',
    },
    {
      name: "difficulty",
      header: "",
      content:
        '<span class="" style="color:#777" title="{{metrics.difficultyString}}">{{metrics.CEF}}</span>',
    },
    {
      name: "permissions",
      header: "",
      content: `<i
          title="{{#public}}{{#hide}}Anyone with the link can access{{/hide}}{{^hide}}Public{{/hide}}{{/public}}{{^public}}Private{{/public}}"
          class="permission icon-{{#public}}{{#hide}}unlock{{/hide}}{{^hide}}globe{{/hide}}{{/public}}{{^public}}lock{{/public}}">
        </i>`,
    },
    {
      name: "owner",
      header: "Owner",
      content:
        '<a href="/user/{{ownerID._id}}" title="{{ownerID.username}}">{{ownerID.shortUsername}}</a>',
    },
    {
      name: "wordCount",
      header: "Total<br>Words",
      content: "{{totalWordsString}}",
    },
    {
      name: "readStatus",
      header: "Status",
      content:
        "{{^readPercentage}}{{readStatus}}{{/readPercentage}}{{#readPercentage}}Read {{readPercentage}}%{{/readPercentage}}",
    },
  ],
  dateFromObjectId: function (objectId) {
    return new Date(
      parseInt(objectId.substring(0, 8), 16) * 1000
    ).toLocaleDateString();
  },
  renderBookTable: function () {
    const header =
      "<thead><tr>" +
      _.map(
        this.columns,
        (column) =>
          '<th class="col-' + column.name + '">' + column.header + "</th>"
      ).join("") +
      "</tr></thead>";
    const rows = [];

    this.books.each((book) => {
      rows.push(this.getBookHtml(book));
    });

    if (rows.length === 0) {
      rows.push(
        '<tr><td colspan="42" style="text-align:center">No texts found</td></tr>'
      );
    }
    this.$el
      .find("table.texts")
      .html(header + "<tbody>" + rows.join("") + "</tbody>");
    Sortable.create(this.$el.find("table.texts tbody")[0], {
      handle: ".col-dragHandle",
      animation: 150,
      onUpdate: () => {
        if (this.shelf) {
          const books = [];
          const oldBooksList = this.shelf.get("books");

          this.$("tr[data-bookID]").each((index, row) => {
            const bookID = $(row).attr("data-bookID");

            books.push(_.findWhere(oldBooksList, { bookID }));
          });

          this.shelf.save({ books }, { patch: true });
        }
      },
    });
    listActionsButton.setup(
      this.$el.find(".texts.actions.dropdown"),
      this.$el.find('input[type="checkbox"][data-bookID]')
    );

    if (this.options.shelfID && this.options.shelfID !== "unshelved") {
      this.$el.find("table.texts").addClass("shelfMode");
    } else {
      this.$el.find("table.texts").removeClass("shelfMode");
    }
  },
  getBookHtml: function (book) {
    const bookJSON = book.viewJSON(this.models.user.id, false);
    bookJSON.createdDate = this.dateFromObjectId(book.id);
    if (bookJSON.userBook) {
      if (_.contains(bookJSON.userBook.tags, "queue")) {
        bookJSON.readStatus = "To Read";
        bookJSON.readPercentage = bookJSON.readTo;
      } else if (_.contains(bookJSON.userBook.tags, "completed")) {
        bookJSON.readStatus = "Completed";
      } else if (_.contains(bookJSON.userBook.tags, "abandoned")) {
        bookJSON.readStatus = "Archived";
      }
    }

    if (bookJSON.userBook) {
      bookJSON.userBook.positionString = utils.addCommasToNumber(
        bookJSON.userBook.position
      );
    }
    if (typeof bookJSON.metrics?.words === "number") {
      bookJSON.totalWordsString = utils.addCommasToNumber(
        parseFloat(bookJSON.metrics?.words.toPrecision(3))
      );
    }

    if (bookJSON.ownerID) {
      bookJSON.ownerID.shortUsername = utils.elide(
        bookJSON.ownerID.username,
        12
      );
    }

    const rowClasses = ["subtleContainer"];
    if (
      bookJSON.status === "notAvailable" ||
      (this.shelf && this.shelf.get("public") && !bookJSON.public)
    ) {
      rowClasses.push("notAvailable");
    }

    return (
      '<tr class="' +
      rowClasses.join(" ") +
      '" data-bookID="' +
      book.id +
      '">' +
      _.map(
        this.columns,
        (column) =>
          '<td class="col-' +
          column.name +
          '">' +
          mustache.to_html(
            column.content,
            _.extend(bookJSON, { groupID: "GROUP_ID" /*this.model.id*/ })
          ) +
          "</td>"
      ).join("") +
      "</tr>"
    );
  },
  filterTextsBasedOnShelf: function (options) {
    this.books.each((book) => {
      this.showOrHideBook(book, options);
    });
  },
  $book: function (book) {
    return this.$('tr[data-bookID="' + book.id + '"]');
  },
  showOrHideBook: function (book, options) {
    if (this.shouldShowBook(book)) {
      this.$book(book).show();
    } else {
      // I'd prefer to use fadeOut() here, but unfortunately the change event gets triggered
      // twice, first upon the Book.save() call and then again when the server response is
      // received, resulting in a duplicate fade out which looks glitchy and confusing.
      // this.$book(book).fadeOut();
      this.$book(book).hide();
      if (options.amendSelection) {
        this.books.selectionModel.removeItem(book.id);
      }
    }
  },
  shouldShowBook: function (book) {
    if (this.shelf) {
      return this.shelf.getBookIndex()[book.id];
    } else if (this.options.tag) {
      return this.containsTag(book, this.options.tag);
    }
    return true;
  },

  containsTag: function (book, tagName) {
    if (tagName === "all") {
      return (
        book.hasTag("queue") ||
        book.hasTag("completed") ||
        book.hasTag("abandoned")
      );
    }
    return book.hasTag(tagName);
  },

  addToShelf: function () {
    console.log("TODO: display shelf selector");
  },
  removeTexts: function () {
    console.log("TODO: remove texts");
  },

  events: {
    "click .checkboxLabel": "clickCheckboxLabel",
  },
  clickCheckboxLabel: function (event) {
    event.stopPropagation();
    event.preventDefault();

    const $label = $(event.currentTarget);
    this._clickCheckbox($("#" + $label.attr("for")), event.shiftKey);
  },
  _clickCheckbox: function (thisCheckbox, shiftKey) {
    const bookID = thisCheckbox.attr("data-bookID");
    let checked = !thisCheckbox.prop("checked");

    if (shiftKey && this.prevCheckbox) {
      // select all items between the original and this one
      var range = this.$el.find('input[type="checkbox"]');

      const index1 = range.index(thisCheckbox);
      const index2 = range.index(this.prevCheckbox);

      range = range.slice(
        Math.min(index1, index2),
        Math.max(index1, index2) + 1
      );

      checked = this.prevCheckboxChecked;
      range = _.map(range, (el) => $(el).attr("data-bookID"));
    }

    this.prevCheckbox = thisCheckbox;
    this.prevCheckboxChecked = checked;

    setTimeout(() => {
      if (checked) {
        if (range) {
          this.books.selectionModel.addItems(range);
        } else {
          this.books.selectionModel.addItem(bookID);
        }
      } else {
        if (range) {
          this.books.selectionModel.removeItems(range);
        } else {
          this.books.selectionModel.removeItem(bookID);
        }
      }
    }, 0);
  },
});

export default PrivateLibraryListView;
